export default __webpack_public_path__ + "static/media/presentation.765b9362.pptx";